'use client';

import Link from 'next/link';
import Reveal from './Reveal';

export default function StartChatCta() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <Reveal>
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">さぁ、チャットを開始しましょう！</h2>
          <p className="mt-2 text-gray-800">今すぐ試して、体験で確かめてください。</p>
          <div className="mt-6 flex justify-center">
            <Link
              href="/chat"
              aria-label="チャットを開始（チャットへ移動）"
              className="px-6 py-3 rounded-md bg-blue-700 text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
              チャットを開始
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
